import React, {Suspense, lazy, useEffect, useState} from "react";
import {Redirect, Switch, Route} from "react-router-dom";
import {LayoutSplashScreen, ContentRoute} from "../../../_metronic/layout";
// import {AuthPage} from "./modules/Auth"
import OrdersPage from "./Orders/OrdersPage";
import AccountSettingsPage from '../Buyer/AccountSettingsPage'
import {useSelector} from "react-redux";
import {SupplierDashboardPage} from "./Dashboard/SupplierDashboardPage"
import {ClientsPage} from "./Clients/ClientsPage";
import ApplicationsPage from "./Applications/ApplicationsPage";
import AnalyticsPage from './Analytics/AnalyticsPage'
import RoutesPage from "./Routes/RoutesPage";
import {SupplierInformation} from "../Admin/Suppliers/SupplierInformation";
import SupplierAdminPage from "../Admin/Suppliers/SupplierAdminPage";
import ProductsAdminPage from "../Admin/Products/ProductsAdminPage";
import UserAdminPage from "../Admin/Users/UserAdminPage";
import { fetchSupplierClients } from "../Admin/AdminPagesCrud";
import ProductPricesAdminPage from "../Admin/Products/ProductPricesAdminPage";

const GoogleMaterialPage = lazy(() =>
    import("../../modules/GoogleMaterialExamples/GoogleMaterialPage")
);
const ReactBootstrapPage = lazy(() =>
    import("../../modules/ReactBootstrapExamples/ReactBootstrapPage")
);
const ECommercePage = lazy(() =>
    import("../../modules/ECommerce/pages/eCommercePage")
);

export default function SupplierBasePage(props) {
    // useEffect(() => {
    //   console.log('Base page');
    // }, []) // [] - is required if you need only one call
    // https://reactjs.org/docs/hooks-reference.html#useeffect
    

    const {user,accessToken} = useSelector (
        ({auth}) =>({
            user: auth.user != null ? auth.user : null,
            accessToken: auth.authToken,
        })
    )

    const [roles, setRoles] = useState(user.roles)
    const [tenantSuppliers, setTenantSuppliers] = useState([])
    const [supplierClients, setSupplierClients] = useState([])
    const [supplierClientTenantIds, setSupplierClientTenantIds] = useState([])
    const [isDataFetched, setIsDataFetched] = useState(false)

    useEffect(() => {

        fetchSupplierClients(accessToken).then(response => {
    
            console.log("Supplier Clients: ", response.data)
            setTenantSuppliers(response.data.tenantSuppliers)
            setSupplierClients(response.data.clients)
            setSupplierClientTenantIds(response.data.tenantIds)
            setIsDataFetched(true)
    
        }).catch(error => console.log(error))
      }, [  ])

    const accountType = useSelector(state => state.auth.user.type)

    return (
            <Suspense fallback={<LayoutSplashScreen/>}>
                <Switch>
                    {props.pathName === 'orders' &&
                        <Redirect exact from="/" to="/orders"/>
                    }
                    {props.pathName === 'applications' &&
                        <Redirect exact from="/" to={`/applications/${props.pathId}`}/>
                    }
                    {
                        /* Redirect from root URL to /dashboard. */
                        roles.includes("supplier_route_management") ?
                            <Redirect exact from="/" to="/routes"/>
                        :
                            <Redirect exact from="/" to="/orders"/>
                    }
                    <Route path="/dashboard" render={(props) => <SupplierDashboardPage accountType={accountType} {...props} />}/>
                    <ContentRoute path="/applications" component={ApplicationsPage}/>
                    <ContentRoute path="/orders/pending_approval" component={OrdersPage} pathId={props.pathId}
                                    status={"Pending Approval"}/>
                    <ContentRoute path="/orders/approved" component={OrdersPage} pathId={props.pathId}
                                    status={"Approved"}/>
                    <ContentRoute path="/orders/:orderId" component={OrdersPage} pathId={props.pathId}/>
                    <ContentRoute path="/orders" component={OrdersPage} pathId={props.pathId}/>
                    <ContentRoute path="/routes" component={RoutesPage}/>
                    <ContentRoute path="/myclients" component={ClientsPage}/>
                    <ContentRoute path="/analytics" component={AnalyticsPage}/>
                    <ContentRoute path="/accountsettings" component={AccountSettingsPage}/>
                    <ContentRoute path="/supplierAdmin/suppliers" component={SupplierAdminPage}/>
                    <ContentRoute path="/supplierAdmin/products" component={ProductsAdminPage} 
                                    supplierClients={supplierClients} />
                    <ContentRoute path="/supplierAdmin/productPrices" component={ProductPricesAdminPage} 
                                    supplierClients={supplierClients} />
                    <ContentRoute path="/supplierAdmin/users" component={UserAdminPage} supplierClients={supplierClients}
                                    supplierClientTenantIds={supplierClientTenantIds} isDataFetched={isDataFetched}
                                    tenantSuppliers={tenantSuppliers}/>
                    <ContentRoute path="/supplierAdmin/:id" component={SupplierInformation}/>
                    <Route path="/google-material" component={GoogleMaterialPage}/>
                    <Route path="/react-bootstrap" component={ReactBootstrapPage}/>
                    <Route path="/e-commerce" component={ECommercePage}/>
                    <Redirect to="error/error-v1"/>
                </Switch>
            </Suspense>
    );
}
